import { Link, useLocation } from "react-router-dom";
import { DESTINATIONS } from "./sections";
import useKeyboardOpen from "../../lib/useKeyboardOpen";

export default function MobileTabs() {
  const loc = useLocation();
  const kbOpen = useKeyboardOpen();
  if (kbOpen) return null;

  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-paper/90 backdrop-blur-xl border-t border-hairline pb-[env(safe-area-inset-bottom)] [transform:translateZ(0)]" data-testid="mobile-tab-bar">
      <div className="grid grid-cols-5">
        {DESTINATIONS.map((d) => {
          const active = loc.pathname.startsWith(d.root);
          const Icon = d.icon;
          return (
            <Link
              key={d.key}
              to={d.path}
              data-testid={`tab-${d.key}`}
              className={`relative flex flex-col items-center gap-1 pt-2.5 pb-2 ${active ? "text-ember" : "text-sand-500"}`}
            >
              {active && <span className="absolute top-0 w-8 h-[3px] rounded-full bg-ember" />}
              <Icon size={20} strokeWidth={active ? 2.4 : 2} />
              <span className="font-mono text-[9px] font-semibold uppercase tracking-wide">{d.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
